import script from "./DropdownWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownWrapper.vue?vue&type=script&setup=true&lang=js"

import "./DropdownWrapper.vue?vue&type=style&index=0&id=7c5e0517&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c5e0517"]])

export default __exports__